import { SCENARIO_QUERY_PARAM as DEVICE_OPTIONS_SCENARIO_QUERY_PARAM } from "@/simulation/device-options/mock-device-options-service";
import {
  MockReplacementOrderService,
  SCENARIO_QUERY_PARAM,
} from "@/simulation/replacement-order/mock-replacement-order-service";
import { cachedAdapters, resolveServiceMode, type ServiceMode } from "@/services/service-mode";
import { HttpReplacementOrderService } from "./replacement-order.http-adapter";
import type { ReplacementOrderService } from "./replacement-order-service";

const SIMULATED_FLOW_QUERY_PARAMS = [SCENARIO_QUERY_PARAM, DEVICE_OPTIONS_SCENARIO_QUERY_PARAM];

export const resolveReplacementOrderServiceMode = (hostname?: string, search?: string): ServiceMode =>
  resolveServiceMode(SIMULATED_FLOW_QUERY_PARAMS, hostname, search);

const buildAdapter = (mode: ServiceMode): ReplacementOrderService =>
  mode === "simulation" ? new MockReplacementOrderService() : new HttpReplacementOrderService();

const createModeSwitchingService = (): ReplacementOrderService => {
  const adapterFor = cachedAdapters(buildAdapter);
  return {
    submit: (request) => adapterFor(resolveReplacementOrderServiceMode()).submit(request),
  };
};

export const createReplacementOrderService = (mode?: ServiceMode): ReplacementOrderService =>
  mode ? buildAdapter(mode) : createModeSwitchingService();
